import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import propTypes from '../../../node_modules/prop-types/index.js';
import Icon from '../Icon/Icon.js';
import { safeRest, rem, noop } from '../../utils/functions.js';
import handle from '../../utils/handle.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { CheckboxWrapper, CheckboxInput, IconWrapper } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["id", "error", "disabled", "customStyle", "onChange"];
var Checkbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      error = _ref.error,
      disabled = _ref.disabled,
      customStyle = _ref.customStyle,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var safeProps = safeRest(rest);

  var _safeCustomStyle = safeCustomStyle(customStyle),
      checkboxStyle = _safeCustomStyle.checkboxStyle;

  var fill = theme.colorPalette.primaryColors.main.shade_default;

  if (disabled) {
    fill = theme.colorPalette.neutralColors.light.shade_dark_3;
  }

  if (error) {
    fill = theme.colorPalette.utilityColors.error;
  }

  return /*#__PURE__*/React.createElement(CheckboxWrapper, {
    checkboxStyle: checkboxStyle
  }, /*#__PURE__*/React.createElement(CheckboxInput, _extends({}, safeProps, {
    id: id,
    type: "checkbox",
    disabled: disabled,
    error: error,
    onChange: handle(onChange),
    theme: theme,
    ref: ref
  })), /*#__PURE__*/React.createElement(IconWrapper, {
    className: "checkbox-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    manulifeName: "checkmark",
    fill: fill,
    height: rem(14)
  })));
});
process.env.NODE_ENV !== "production" ? Checkbox.reduxFormProps = {
  inputProp: 'checked',
  inputType: 'boolean'
} : void 0;
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  /** ID of the checkbox */
  id: propTypes.string.isRequired,

  /** Disable the checkbox */
  disabled: propTypes.bool,

  /** Display checkbox error state */
  error: propTypes.bool,

  /** Callback to be called when the checkbox changes */
  onChange: propTypes.func,

  /** Style overrides */
  customStyle: propTypes.shape({
    checkboxStyle: propTypes.object
  })
} : void 0;
Checkbox.defaultProps = {
  disabled: false,
  error: false,
  onChange: noop,
  customStyle: {
    checkboxStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? Checkbox.displayName = 'Checkbox' : void 0;

export default Checkbox;
